<script>
import { onMount } from 'svelte'
import { config } from "./Store/ConfigStore"
import { overlay } from "./Store/OverlayStore"
import { OverlayTriggerService } from "./Service/OverlayTriggerService"
import { allLocations } from "./Store/LocationStores";
import Overlay from "./Component/Overlay.svelte"


export let triggers = [] // HTML nodes that can trigger flyout


onMount( () => {
	$config.debug && console.log( { $config } )

	OverlayTriggerService.listen( triggers )

	$allLocations = $config.locations
} )
</script>

{#if $overlay.visible }
	<Overlay/>
{/if}
